import React from 'react';
import { Button, BUTTON_VARIANTS } from 'afl-design-system';

export const Buttons = () => {
    return (
        <div className="flex flex-column">
            <h3 className="text-title-m">Buttons</h3>
            <div className="mt-m flex gap-s items-center flex-wrap">
                {Object.keys(BUTTON_VARIANTS.VARIANT)
                    .map((variantKey) =>
                        Object.keys(BUTTON_VARIANTS.SIZE)
                            .map((sizeKey) => (
                                <Button
                                    key={`button-${BUTTON_VARIANTS.VARIANT[variantKey]}-${BUTTON_VARIANTS.SIZE[sizeKey]}`}
                                    variant={
                                        BUTTON_VARIANTS.VARIANT[variantKey]
                                    }
                                    size={BUTTON_VARIANTS.SIZE[sizeKey]}
                                >{`${BUTTON_VARIANTS.VARIANT[variantKey]} ${BUTTON_VARIANTS.SIZE[sizeKey]}`}</Button>
                            ))
                            .flat()
                    )
                    .flat()}
            </div>
        </div>
    );
};
